// Versión de la aplicación.
// Se muestra en el Login y se adjunta a cada log de error enviado al backend.
// Al liberar una nueva versión, actualizar APP_VERSION y APP_VERSION_DATE aquí (único lugar).

export const APP_VERSION = "1.0.1.002";
export const APP_VERSION_DATE = "2026/10/09";
export const APP_VERSION_LABEL = `Ver.${APP_VERSION} ${APP_VERSION_DATE}`;
